import { type User } from '@wellesley/openapi'

const getUserNameWithDomain = (user: User) => {
  return `${user.username}${user.local ? '' : `@${user.domain}`}`
}

export { getUserNameWithDomain }
